module.exports = __webpack_public_path__ + "static/media/arrow-down-orange.11d662a5.svg";